import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Badge, Button } from 'antd';
import { 
  HeartOutlined, HeartFilled, UserOutlined, ShoppingCartOutlined 
} from '@ant-design/icons';
import SearchBar from '../searshBar';
import { HeaderActionsProps } from '../interfaces';
import './headerActions.scss';

const HeaderActions: React.FC<HeaderActionsProps> = ({
  isAuthenticated,
  cartItemsCount,
  likedProductCount,
  onCartClick,
  onLikedClick,
  toggleModal,
  className
}) => {
  const location = useLocation();
  return (
    <div className={className ?? 'icon-container'}>
      <div className="icon-container__search">
        <SearchBar />
      </div>

      {isAuthenticated ? (
        <Link
          to="/UserPage"
          className="header-action-link header-action-link--authenticated"
          aria-label="Open account"
        >
          <UserOutlined aria-hidden="true" />
        </Link>
      ) : (
        <Button
          className="header-action-button header-action-button--guest"
          type="text"
          shape="circle"
          icon={<UserOutlined />}
          onClick={toggleModal}
          aria-label="Sign in or create an account"
        />
      )}

      <div className="block-shipping-cart">
        <Badge
          className="header-action-badge"
          count={cartItemsCount}
          overflowCount={99}
          style={{ fontSize: 11, width: 19, height: 19 }}
        >
          <Button
            className="header-action-button"
            type="text"
            shape="circle"
            icon={<ShoppingCartOutlined />}
            onClick={onCartClick}
            aria-label={`Open shopping cart${cartItemsCount ? `, ${cartItemsCount} item${cartItemsCount === 1 ? '' : 's'}` : ''}`}
          />
        </Badge>
      </div>

      <Badge
        className="header-action-badge"
        count={likedProductCount}
        overflowCount={99}
        style={{ fontSize: 11, width: 19, height: 19 }}
      >
        <Button
          className={`header-action-button ${location.pathname === '/product/liked' ? 'header-action-button--liked' : ''}`}
          type="text"
          shape="circle"
          icon={location.pathname === '/product/liked' ? <HeartFilled /> : <HeartOutlined />}
          onClick={onLikedClick}
          aria-label={`Open wishlist${likedProductCount ? `, ${likedProductCount} item${likedProductCount === 1 ? '' : 's'}` : ''}`}
        />
      </Badge>
    </div>
  );
};

export default HeaderActions;
